// Context
import { useBQMQ } from "context/BQMQ.context";

// Styles
import SummaryCardContainer from "./SummaryCard.styles";

// Logger
import { faCaretDown, faCaretUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import Logger from "utils/logger.utils";
import Comments from "../Comments/Comments";
import UserVotesTable from "../UserVotesTable/UserVotesTable";
import VoteCountsTable from "../VoteCountsTable/VoteCountsTable";

const Log = new Logger();
Log.init("SummaryCard");

type Props = {
    factor: string;
    results: any;
    usersVotes: any;
    overallResult: string;
    comments: UserComment[];
    voteCountMode: string;
    setVoteCountMode: React.Dispatch<React.SetStateAction<"QUESTION" | "USER">>;
    sessionDate?: string;
    editVote?: boolean;
    sessionId?: string;
    historicalComments?: UserComment[];
};

export default function SummaryCard({
    factor,
    results,
    overallResult,
    usersVotes,
    comments,
    setVoteCountMode,
    voteCountMode,
    sessionDate,
    historicalComments,
}: Props) {
    const { allFactorsList } = useBQMQ();
    const [showComments, setShowComments] = useState(true);
    const [showHistoricalComments, setShowHistoricalComments] = useState(false);

    return (
        <SummaryCardContainer>
            <div className={"cardInner"}>
                <div className={"title"}>
                    <div className={"left"}>
                        <div
                            className={
                                "overall-result score-" +
                                overallResult?.toString().toUpperCase()
                            }
                        >
                            {overallResult?.toString().toUpperCase()}
                        </div>
                        {allFactorsList[factor]?.name.toUpperCase()}
                    </div>
                    <div
                        style={{
                            maxWidth: "50%",
                            display: "flex",
                            flexDirection: "row",
                        }}
                    >
                        <div
                            data-cy="table-mode-button"
                            className={"tableModeBtn"}
                            onClick={() =>
                                setVoteCountMode(
                                    voteCountMode === "QUESTION"
                                        ? "USER"
                                        : "QUESTION"
                                )
                            }
                        >
                            {voteCountMode === "USER"
                                ? "SHOW BY QUESTION"
                                : "SHOW BY USER"}
                        </div>
                    </div>
                </div>

                {voteCountMode === "QUESTION" ? (
                    <VoteCountsTable
                        results={results}
                        usersVotes={usersVotes}
                        factor={factor}
                        setHighlightedFactor={() => {}}
                    />
                ) : (
                    <UserVotesTable
                        usersVotes={usersVotes}
                        results={results}
                        factor={factor}
                        setHighlightedFactor={() => {}}
                    />
                )}

                <div
                    className={
                        "title dropdown " +
                        showComments
                    }
                    onClick={() => setShowComments(!showComments)}
                >
                    {"COMMENTS"}

                    <FontAwesomeIcon
                        icon={showComments ? faCaretUp : faCaretDown}
                        fixedWidth
                    />
                </div>

                {showComments && (
                    // @ts-ignore allow extra prop for highlighting
                    <Comments comments={comments} sessionDate={sessionDate} />
                )}

                {historicalComments && historicalComments.length > 0 && (
                    <>
                        <div
                            className={
                                "title dropdown " +
                                showHistoricalComments
                            }
                            onClick={() =>
                                setShowHistoricalComments(
                                    !showHistoricalComments
                                )
                            }
                        >
                            {`HISTORICAL COMMENTS (${historicalComments.length})`}

                            <FontAwesomeIcon
                                icon={
                                    showHistoricalComments
                                        ? faCaretUp
                                        : faCaretDown
                                }
                                fixedWidth
                            />
                        </div>
                        {showHistoricalComments && (
                            // @ts-ignore allow extra prop for highlighting
                            <Comments
                                comments={historicalComments}
                                sessionDate={sessionDate}
                            />
                        )}
                    </>
                )}
            </div>
        </SummaryCardContainer>
    );
}
